import { trialDates, useTrialNow } from "../../../views/Subscription/trialDates";
import { DateTime } from "luxon";
import Helpers from "../../../services/Helpers";

export default function SubscriptionDetails({ memberStore, subStore }) {
  const { isNotEmpty } = Helpers();

  const currentSub = subStore.subscription.length > 0 ? subStore.subscription[0] : null;
  const now = useTrialNow(currentSub);
  const dates = currentSub?.internalName === "PFL_TRIAL" ? trialDates(currentSub, now) : null;
  const futureSub = subStore.subscription.length === 2 ? subStore.subscription[1] : null;
  const nextBillingDate = currentSub && currentSub.nextBillingDate ? DateTime.fromSeconds(currentSub.nextBillingDate) : null;
  const lastDay = nextBillingDate ? nextBillingDate.minus({ days: 1 }).toFormat("MMMM d, yyyy") : "";

  if (memberStore.member.admin || memberStore.member.mpFriend) {
    return (
      <div className="card mb-3">
        <div className="card-body p-2">
          <div className="text-center my-2">
            Plan: <strong>{`${memberStore.member.admin ? "Admin" : "Family & Friends"} (no subscription)`}</strong>
          </div>
          <div className="text-center pb-2">
            Status: <strong>Active</strong>
          </div>
        </div>
      </div>
    );
  }

  if (currentSub?.internalName === "MP_GIFT") {
    return (
      <div className="card mb-3">
        <div className="card-body p-2">
          <div className="text-center my-2">{currentSub.plan}</div>
          <div className="text-center pb-2">
            <small className="text-muted">Gift expires on {lastDay}</small>
          </div>
        </div>
      </div>
    );
  }

  if (currentSub?.internalName === "PFL_TRIAL") {
    const dateInfo = dates.lastDay
      ? `${dates.expired ? "Trial expired on" : "Access through"} ${dates.lastDay} (Pacific Time)`
      : "Trial expiration date unavailable";
    return (
      <div className="card mb-3">
        <div className="card-body p-2">
          <div className="text-center my-2">Meal Plan Club trial</div>
          <div className="text-center pb-2">
            <small className="text-muted">
              {dateInfo}
            </small>
          </div>
        </div>
      </div>
    );
  }

  const plan = subStore.plans.find((p) => currentSub?.internalName === p.internalName);
  if (isNotEmpty(plan)) {
    const futurePlan = futureSub && subStore.plans.find((p) => futureSub.internalName === p.internalName);
    if (subStore.subscription.length > 0) {
      let status = "Active";
      let dateInfo = null;
      if (futurePlan) {
        dateInfo = `Plan changes to ${futurePlan.name} for $${futurePlan.price} on ${lastDay}`;
      } else if (currentSub.canceled && nextBillingDate >= DateTime.now()) {
        status = "Canceled";
        dateInfo = `Membership expires on ${lastDay}`;
      } else if (plan) {
        dateInfo = `Next $${plan.price} charge on ${lastDay}`;
      }
      return (
        <div className="card mb-3">
          <div className="card-body p-2">
            <div className="text-center my-2">{plan.name}</div>
            <div className="text-center mb-2">
              Status: <strong>{status}</strong>
            </div>
            <div className="text-center pb-2">
              <small className="text-muted">{dateInfo}</small>
            </div>
          </div>
        </div>
      );
    }
  }
  return null;
}
